import { OauthLoginProvider } from 'multirpc-sdk';

import { trackAnalyticEvent } from './trackAnalyticEvent';
import { AnalyticsEvent } from '../const/AnalyticsEvent';

interface IProperties {
  provider: OauthLoginProvider | null;
}

export const trackAuthenticationCompleted = async (
  properties: IProperties,
): Promise<void> =>
  trackAnalyticEvent({
    event: AnalyticsEvent.AuthenticationCompleted,
    properties,
  });
